<h1 mat-dialog-title>File content</h1>
<mat-dialog-content class="mat-typography" style="white-space: pre-line;">
  {{ content }}
</mat-dialog-content>
<mat-dialog-actions allign="end">
  <button mat-raised-button mat-dialog-close>Cancel</button>
</mat-dialog-actions>
